import { useEffect, useCallback } from 'react';
import confetti from 'canvas-confetti';

// Confetti celebration for deal wins
export function useConfetti() {
  const celebrate = useCallback((options = {}) => {
    const defaults = {
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
      colors: ['#0D7377', '#14919B', '#FFD700', '#FF6B6B', '#4ECDC4']
    };

    // Fire confetti from the center
    confetti({
      ...defaults,
      ...options
    });

    // Fire from the sides for extra effect
    confetti({
      ...defaults,
      angle: 60,
      origin: { x: 0 },
      ...options
    });
    confetti({
      ...defaults,
      angle: 120,
      origin: { x: 1 },
      ...options
    });
  }, []);

  const celebrateDealWon = useCallback(() => {
    // Epic celebration for closing a deal
    const duration = 3000;
    const animationEnd = Date.now() + duration;
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 9999 };

    function randomInRange(min, max) {
      return Math.random() * (max - min) + min;
    }

    const interval = setInterval(function() {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      const particleCount = 50 * (timeLeft / duration);
      
      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
        colors: ['#0D7377', '#14919B', '#FFD700']
      });
      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
        colors: ['#0D7377', '#14919B', '#FFD700']
      });
    }, 250);
  }, []);

  const celebrateQuoteAccepted = useCallback(() => {
    confetti({
      particleCount: 80,
      spread: 60,
      origin: { y: 0.7 },
      colors: ['#22c55e', '#16a34a', '#4ade80']
    });
  }, []);

  return { celebrate, celebrateDealWon, celebrateQuoteAccepted };
}

// Hook to trigger confetti on deal status change
export function useDealCelebration(dealStatus, previousStatus) {
  const { celebrateDealWon } = useConfetti();

  useEffect(() => {
    if (previousStatus && dealStatus === 'closed_won' && previousStatus !== 'closed_won') {
      celebrateDealWon();
    }
  }, [dealStatus, previousStatus, celebrateDealWon]);
}

export default useConfetti;
